import { isRouteErrorResponse, useRouteError } from "react-router";
import { paths } from "../../app/paths";
import { NotFoundPage } from "./NotFoundPage";
import { StatusPage } from "./StatusPage";

/** Router-level error element (WEB-008): route loader/render failures and failed chunk loads. */
export function RouteErrorPage() {
  const error = useRouteError();

  if (isRouteErrorResponse(error) && error.status === 404) return <NotFoundPage />;

  const details = import.meta.env.DEV ? describe(error) : undefined;
  return (
    <StatusPage
      code="Something went wrong"
      title="This page couldn't be displayed"
      action={{ href: paths.home, label: "Reload from the home page" }}
      {...(details === undefined ? {} : { details })}
    >
      <p>
        Nothing you entered on other pages was affected. Reload to try again. If this keeps
        happening, contact support and mention the time it occurred.
      </p>
    </StatusPage>
  );
}

function describe(error: unknown): string {
  if (isRouteErrorResponse(error)) return `${error.status} ${error.statusText}`;
  if (error instanceof Error) return `${error.name}: ${error.message}\n${error.stack ?? ""}`;
  return String(error);
}
